import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { objectToParams } from '../constants';
import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';

import { RestService } from '../shared/rest.service';
import { ActivatedRoute, Router } from '@angular/router';
import { _ROUTER_CONFIG } from '@ngrx/router-store/src/router_store_module';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../shared/auth.service';
import { CustomTranslateService } from 'app/shared/custom-translate.service';
import { Observable } from 'rxjs';
import { FuseSplashScreenService } from '../../@fuse/services/splash-screen.service';
import { PageService } from 'app/main/pages/pages.service';
import { views } from 'app/navigation/navigation';

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent implements OnInit {
    loginForm: FormGroup;
    isCreateAccount: boolean = false;
    isForgotPassword: boolean = true;
    verificationCode: FormControl = new FormControl('', [Validators.required]);
    isOTPSent: boolean = false;
    NumList: any[] = [];
    resendCount: number = 0;
    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        private _restService: RestService,
        private _router: Router,
        private _toastr: ToastrService,
        private _authService: AuthService,
        private _customTranslateService: CustomTranslateService,
        private _translateService: TranslateService,
        private _fuseSplashScreenService: FuseSplashScreenService,
        private _pageService: PageService,
        private chRef: ChangeDetectorRef,
        private _activeRoute: ActivatedRoute,
    ) {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer: {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };
        this._activeRoute.params.subscribe((routeParams: any) => {
            const params = { ...this._activeRoute.snapshot.queryParams };
            var key = params.key;
            var token = params.token;
            if(key != undefined && token != undefined) {
                var request = objectToParams({
                    username: key,
                    password: key,
                    grant_type: 'password',
                    SSO: token
                  });
                  this._fuseSplashScreenService.show();
                  this._restService.Token(request).subscribe((result) => {
                    if (result) {
                        this._authService.sendToken(result);
                        this.userProfile();
                    }
                    else {
                        this._fuseSplashScreenService.hide();
                    }
                  }, (error) =>{
                    this._fuseSplashScreenService.hide();
                    if (error.status == 0) {
                        this._toastr.error(error.message, 'Error');
                    }
                    else {
                        this._toastr.error(error.error.error_description, 'Error');
                    }
                  })
            }         
        });  
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.loginForm = this._formBuilder.group({
            username: ['', [Validators.required]],
            password: [null, [Validators.required, Validators.minLength(8)]],
            PhoneId: ['']
        });
    }
    isPageExist(arr: any, page: string) {
        return arr.some(function (el) {
            return el == page;
        });
    }
    findItems(obj: any, page: string) {
        let foundObj = obj.filter(x => ((x.type === 'item') && (x.id == page)));
        if (foundObj && foundObj.length > 0) {
            return foundObj[0];
        }
        let collapsableArr = obj.filter(x => ((x.type === 'collapsable')));
        let groupObj;
        if (collapsableArr && collapsableArr.length > 0) {
            collapsableArr.forEach((child) => {
                let foundObj = child.children.filter(x => ((x.type === 'item') && (x.id == page)));
                if (foundObj && foundObj.length > 0) {
                    groupObj = foundObj[0];
                }
            });
            if (groupObj) {
                return groupObj;
            }
        }
    }

    userProfile() {
        const self = this;
        self._restService.GetUserProfile().subscribe(
            (res: any) => {
                self._fuseSplashScreenService.hide();
                let role: any = res.data.roles[0];
                let companyRoles: any = res.data.companyRoles ? res.data.companyRoles : [];
                let agentRoles: any = res.data.agentRoles ? res.data.agentRoles.pages : (res.data.companyRoles ? res.data.companyRoles : []);
                if (role == 'agent') {
                    if (res.data.isAdminAccess) {
                        role = 'company'
                        res.data.roles[0] = role;
                        res.data.defaultAgentView = false;
                    }
                    else if (!this.isPageExist(agentRoles, 'corporate-reporting')) {
                        res.data.defaultAgentView = true;
                    }
                }
                if(res.data && !res.data.isLocalDSReport) {
                    res.data.isLocalDSReport = true;
                }
                self._authService.sendUserData(JSON.stringify(res.data));
                self._pageService.init();
                if (role == 'company') {
                    if (companyRoles.length > 0) {
                        if (this.isPageExist(companyRoles, 'home')) {
                            self._router.navigate(['pages/dashboard']);
                        }
                        else {
                            let page = this.findItems(views, companyRoles[0]);
                            if (page) {
                                let pageUrl = page.url;
                                self._router.navigate([pageUrl]);
                            }
                            else {
                                self._authService.logout();
                                self._toastr.warning('Please contact to your admin for permissions', 'Warning');
                            }
                        }
                    }
                    else {
                        self._authService.logout();
                        self._toastr.warning('Please contact to your admin for permissions', 'Warning');
                    }
                }
                else if (role == 'agent') {
                    if (agentRoles.length > 0) {
                        if (this.isPageExist(agentRoles, 'home')) {
                            self._router.navigate(['pages/dashboard']);
                        }
                        else {
                            let page = this.findItems(views, companyRoles[0]);
                            if (page) {
                                let pageUrl = page.url;
                                self._router.navigate([pageUrl]);
                            }
                            else {
                                self._authService.logout();
                                self._toastr.warning('Please contact to your admin for permissions', 'Warning');
                            }
                        }
                    }
                    else {
                        self._authService.logout();
                        self._toastr.warning('Please contact to your admin for permissions', 'Warning');
                    }
                }
                else {
                    self._router.navigate(['pages/dashboard']);
                }
            },
            error => {
                self._fuseSplashScreenService.hide();
                console.log(error);
            }
        )
    }

    verifyCode() {
        if (this.loginForm.valid && this.verificationCode.valid) {
            const self = this;
            if(this.NumList.length>0) {
                var request = objectToParams({
                    username: this.loginForm.value.username,
                    password: this.loginForm.value.password,
                    VerificationCode: this.verificationCode.value,
                    grant_type: 'password',
                    PhoneId: this.loginForm.value.PhoneId
                });
             }else {
                var request = objectToParams({
                    username: this.loginForm.value.username,
                    password: this.loginForm.value.password,
                    VerificationCode: this.verificationCode.value,
                    grant_type: 'password'
                });
             }

            self._fuseSplashScreenService.show();
            self._restService.Token(request).subscribe((result) => {
                if (result) {
                    this._authService.sendToken(result);
                    this.userProfile();
                }
                else {
                    self._fuseSplashScreenService.hide();
                }
            }, function (error) {
                self._fuseSplashScreenService.hide();
                console.log(error);
                if (error && error.error && error.error.error) {
                    if( error.error.error == "invalid_grant") {
                        self._toastr.error('Invalid Code', 'Error');
                    }
                    else {
                        self._toastr.error('Login Failed', 'Error');
                    }
                }
                else {
                    self._toastr.error('Login Failed', 'Error');
                }
            })
        }
    }
    resendOTP() {
        if (this.loginForm.valid) {
            const self = this;
            if(this.NumList.length>0) {
                var request = objectToParams({
                    username: this.loginForm.value.username,
                    password: this.loginForm.value.password,
                    grant_type: 'password',
                    PhoneId: this.loginForm.value.PhoneId
                });
             }else {
                var request = objectToParams({
                    username: this.loginForm.value.username,
                    password: this.loginForm.value.password,
                    grant_type: 'password'
                });
             }
            self._fuseSplashScreenService.show();
            self._restService.Token(request).subscribe((result) => {
                self._fuseSplashScreenService.hide();
            }, function (error) {
                self._fuseSplashScreenService.hide();
                console.log(error);
                if (error && error.error && error.error.error) {
                    if (error.error.error == "interaction_required") {
                        self._toastr.info('Please provide two step verification code', 'Info');
                        self.isOTPSent = true;
                    }
                    else if (error.error.error == "invalid_grant") {
                        self._toastr.error('Username or Password is incorrect', 'Error');
                    }
                    else {
                        self._toastr.error('Login Failed', 'Error');
                    }
                }
                else {
                    self._toastr.error('Login Failed', 'Error');
                }
            })
        }
    }
    onLogin() {
        if (this.loginForm.valid) {
            const self = this;
            self.resendCount++;
            if(this.NumList.length>0) {
                var request = objectToParams({
                    username: this.loginForm.value.username,
                    password: this.loginForm.value.password,
                    PhoneId: this.loginForm.value.PhoneId,
                    grant_type: 'password'
                });
            }else {
                var request = objectToParams({
                username: this.loginForm.value.username,
                password: this.loginForm.value.password,
                grant_type: 'password'
            });
            }

            self._fuseSplashScreenService.show();
            self._restService.Token(request).subscribe((result) => {
                if (result) {
                    this._authService.sendToken(result);
                    this.userProfile();
                }
                else {
                    self._fuseSplashScreenService.hide();
                }
            }, function (error) {
                self._fuseSplashScreenService.hide();
                if (error && error.error && error.error.error) {
                    if (error.error.error == "interaction_required") {
                        self._toastr.info('Please provide two step verification code', 'Info');
                        self.isOTPSent = true;
                        self.chRef.detectChanges();
                    }else if (error.error.error == "account_selection_required") {
                        self._toastr.info(error.error.error_description);
                        var data = JSON.parse(error.error.scope);
                        self.NumList = data;
                        self.NumList.sort(function(a, b) {
                            return a.ID - b.ID;
                        });
                        self.chRef.detectChanges();
                        self.loginForm.get('PhoneId').setValue(self.NumList[0].ID);
                        self.chRef.detectChanges();
                    }
                    else if (error.error.error == "invalid_grant") {
                        self._toastr.error('Username or Password is incorrect', 'Error');
                    }else if (error.error.error == "temporarily_unavailable") {
                        self._toastr.info(error.error.error_description, 'Info');
                    }
                    else {
                        self._toastr.error('Login Failed', 'Error');
                    }
                }
                else {
                    self._toastr.error('Login Failed', 'Error');
                }
            })
        }
    }
}
